var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandle2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1230_42699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H80V80H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1230_42699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6562 2.34375H2.34375V63.2812H77.6562V2.34375Z",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 25.7812C40 33.5478 33.7041 39.8438 25.9375 39.8438C18.1709 39.8438 11.875 33.5478 11.875 25.7812C11.875 18.0147 18.1709 11.7188 25.9375 11.7188C33.7041 11.7188 40 18.0147 40 25.7812Z",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 25.7812H25.9375V11.7188",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.375 56.25V46.875",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.75 56.25V28.125",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.125 56.25V37.5",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.375 11.7188H68.125",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.125 21.0938H49.375",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3125 49.2188H16.5625",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0312 63.2813V77.6562",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9688 77.6562V63.2813",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5938 77.6562H56.4062",
    stroke: "#FE4747",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandle2);
export default __webpack_public_path__ + "static/media/handle2.34d9220cb1d8db358150bfe4e8c90070.svg";
export { ForwardRef as ReactComponent };